import React, { useContext, useEffect, useRef, useState } from "react";
import Constant from "../../Constants";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import CollapsibleCard from "../../Articles/UpsertArticle/CollapsibleCard";
import ContractProgress from "./ContractProgress";
import { useNavigate, useParams } from "react-router-dom";
import CollapsibleCardItem from "../../Articles/UpsertArticle/CollapsibleCardItem";
import ContractTimeline from "./ContractTimeline";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import toast from "react-hot-toast";
import moment from "moment";
import { Loader } from "../../Common";
import { parseInt } from "lodash";
import Placement from "./ContractPlacement";
import PlacementCheck from "./ContractCheck";

import "./style.css";

const ContractDetails = () => {
  const { placementItems, categoryOptions, linkTypeItems } = Constant();
  const { t } = useContext(LanguageContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);
  const [isPending, setPending] = useState(false);
  const [timelineData, setTimeLine] = useState({});
  const [stage, setStage] = useState({
    remainingTime: "",
    formattedEndTime: "",
  });
  const [loadingStates, setLoadingStates] = useState({});
  const [isQualityReportActive, setIsQualityReportActive] = useState(false);
  const [basicDetails, setBasicDetails] = useState({
    domain: "",
    da: "",
    dr: "",
    traffic: "",
    categories: [],
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [sellerTerms, setSellerTerm] = useState({});
  const [isValidPlacement, setIsValidPlacement] = useState(null);
  const [actionData, setActionData] = useState([]);
  const [isHide, setIsHide] = useState(false);
  const [pageData, setPageData] = useState({
    url: null,
    checks: [],
    checked: null,
  });
  const [value, setValue] = useState({
    title: "",
    annotation: "",
    content: "",
    uuid: null,
  });
  const [contractData, setContractData] = useState({
    domain_uuid: "",
    seller_uuid: "",
    type: "",
    niche: "",
    rel: "",
    links: "",
    price: "",
    money_back_policy: "",
    link_replacement_policy: "",
    status: "",
    code: "",
  });
  const [isDisable, setDisable] = useState({
    action: false,
    reason: false,
  });

  const QualityCheck = [
    {
      id: "word-count",
      title: t("Words Count"),
      pass:
        value?.annotation?.quality?.words == null
          ? null
          : value?.annotation?.quality.words >= 607,
      tag: `${value?.annotation?.quality?.words ?? 0} ${t("Words")}`,
      description: t(
        "To meet the requirements of more sellers, we recommend keeping your content within the average range specified across all offers: a minimum of 607 words and a maximum of 4,560 words"
      ),
      type: 9,
    },
    {
      id: "plagiarism",
      title: t("Plagiarism"),
      pass: value?.annotation?.quality?.plagiarism?.passed ?? null,
      tag: `${
        value?.annotation?.quality?.plagiarism?.passed === null ||
        value?.annotation?.quality?.plagiarism === null
          ? t("Not Checked")
          : t("Detected")
      }`,
      description: t(
        "Approximately 90% of sellers require content that is unique and has never been published before. To increase your publication opportunities, we recommend keeping plagiarized (or similar to already published) content below 15%"
      ),
      type: 2,
      recommended: true,
      forceCheckType: 51,
    },
    {
      id: "readability",
      title: t("Readability"),
      pass: value?.annotation?.quality?.readability?.passed ?? null,
      tag: `${
        value?.annotation?.quality?.readability?.passed
          ? t("Fairly Easy")
          : t("Not Detected")
      }`,
      description: t(
        "For optimal SEO, aim for a Flesch Reading Ease score between 60 and 70, equivalent to an 8th-grade reading level. This balance ensures your content is easily understood by a broad audience while effectively conveying valuable information"
      ),
      type: 4,
    },
    {
      id: "seo",
      title: t("SEO"),
      pass: value?.annotation?.quality?.seo?.passed ?? null,
      tag: `${
        value?.annotation?.quality?.seo?.passed
          ? t("Optimized")
          : t("Not Detected")
      }`,
      description: t(
        "Proper SEO formatting is essential as it helps search engine crawlers understand the structure and content of a webpage, improving its relevance to specific search queries and influencing its ranking on search engine results pages (SERPs)"
      ),
      type: 3,
    },
    {
      id: "image",
      title: t("Image"),
      pass: value?.annotation?.quality?.image?.passed ?? null,
      tag: `${value?.annotation?.quality?.images ?? 0} ${t("Image")}`,
      description: t(
        "Around 30% of sellers require content that includes at least one unique image. We recommend incorporating images as they greatly enhance SEO by making your content more engaging, accessible, and visually appealing to users. Properly optimized and indexed images can also improve search engine rankings"
      ),
      type: 1,
    },
    {
      id: "ai-generated-content",
      title: t("AI Generated Content"),
      pass: value?.annotation?.quality?.ai?.passed ?? null,
      tag: `${
        value?.annotation?.quality?.ai?.passed === null ||
        value?.annotation?.quality?.ai === null
          ? t("Not Checked")
          : t("Detected")
      }`,
      description: t(
        "Around 30% of sellers require content that includes at least one unique image. We recommend incorporating images as they greatly enhance SEO by making your content more engaging, accessible, and visually appealing to users. Properly optimized and indexed images can also improve search engine rankings"
      ),
      type: 5,
      recommended: true,
      forceCheckType: 52,
    },
  ];

  const handleLoadingState = (index, isLoading) => {
    setLoadingStates((prevState) => ({
      ...prevState,
      [index]: isLoading,
    }));
  };

  const fetchContracts = () => {
    const url = `/users/${userData?.uuid}/contracts/${id}`;
    axiosInstance
      .get(url)
      .then((response) => {
        setContractData(response?.data || {});
      })
      .catch(() => {
        toast.error(t("There was an error fetching contracts"));
      });
  };
  const fetchPageData = (isContract) => {
    const url = `/users/${userData?.uuid}/contracts/${id}/page`;
    axiosInstance
      .get(url)
      .then((response) => {
        if (response?.status >= 200 && response?.status < 300) {
          setPageData(response?.data || {});
          if (response?.data?.checks?.length > 0) {
            const isAllSolved = response?.data?.checks?.every(
              (check) => check?.solved === true
            );
            setIsValidPlacement(isAllSolved);
            if (isAllSolved) {
              setDisable({ reason: false, action: false });
              setIsHide(true);
            } else if (isAllSolved && isContract) {
              setIsHide(true);
            } else {
              setDisable({ action: true, reason: false });
            }
          } else {
            setIsValidPlacement(true);
            setDisable({ action: true, reason: false });
          }
        } else {
          setPageData({
            url: null,
            checks: [],
          });
          setIsValidPlacement(null);
          setDisable({ action: true, reason: false });
        }
      })
      .catch(() => {
        setPageData({
          url: null,
          checks: [],
        });
        setIsValidPlacement(null);
        setDisable({ action: true, reason: false });
      });
  };

  const fetchArticles = () => {
    setIsQualityReportActive(null);
    const url = `/users/${userData?.uuid}/contracts/${id}/article`;
    axiosInstance
      .get(url)
      .then((response) => {
        setIsQualityReportActive(false);
        const { title, content, uuid, ...annotation } = response?.data;

        setValue({
          title: title,
          content: content,
          annotation: annotation,
          uuid: uuid,
        });
      })
      .catch(() => {
        toast.error(t("There was an error fetching articles"));
      });
  };

  const fetchTimeline = () => {
    const url = `/users/${userData?.uuid}/contracts/${id}/timeline`;
    axiosInstance
      .get(url)
      .then((response) => {
        setTimeLine(response?.data?.stages || []);
      })
      .catch(() => {
        toast.error(t("There was an error fetching Timeline data"));
      });
  };

  useEffect(() => {
    contractData?.status === 9 ? setIsHide(true) : setIsHide(false);
  }, [contractData]);

  const fetchAddressBar = () => {
    const url = `/users/${userData?.uuid}/contracts/${id}/actions`;
    axiosInstance
      .get(url)
      .then((response) => {
        fetchTimeline();
        setActionData(response?.data || []);
      })
      .catch(() => {
        toast.error(t("There was an error fetching Actions"));
      });
  };

  useEffect(() => {
    if (timelineData && timelineData?.length >= 1) {
      const currentStage = timelineData?.find((stage) => stage.active);

      if (currentStage) {
        const now = moment();
        const endTime = moment(currentStage.end);

        // Calculate remaining duration
        const remainingDuration = moment.duration(endTime.diff(now));

        // Ensure no negative duration
        if (remainingDuration.asMilliseconds() < 0) {
          // If the remaining duration is negative (i.e., the time has passed)
          setStage({
            remainingTime: t("Expired"),
            formattedEndTime: endTime.format("MMM D"),
          });
          return;
        }

        const formattedEndTime = endTime.format("MMM D"); // Format the end date

        let remainingTime = "";

        if (remainingDuration.days() > 1) {
          remainingTime = `${remainingDuration.days()} ${t("days")} ${t(
            "left"
          )}`;
        } else if (remainingDuration.hours() > 0) {
          remainingTime = `${remainingDuration.hours()} ${t("hours")} ${t(
            "left"
          )}`;
        } else if (remainingDuration.minutes() > 0) {
          // Less than 1 hour but more than 1 minute
          remainingTime = `${remainingDuration.minutes()} ${t("minutes")} ${t(
            "left"
          )}`;
        } else {
          // Less than 1 minute (in seconds)
          remainingTime = `${remainingDuration.seconds()} ${t("seconds")} ${t(
            "left"
          )}`;
        }

        // Update state with remaining time and formatted end time
        setStage({ remainingTime, formattedEndTime });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timelineData, t]);

  const fetchSellerTerms = () => {
    const url = `/domains/${contractData?.domain_uuid}/sellers/${contractData?.seller_uuid}/terms`;
    axiosInstance
      .get(url)
      .then((response) => {
        setSellerTerm(response?.data || {});
      })

      .catch(() => {
        toast.error(t("There was an error fetching Seller Terms"));
      });
  };

  const hasFetched = useRef(false);
  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      fetchContracts();
      fetchArticles();
      fetchTimeline();
      fetchAddressBar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (
      contractData?.status &&
      (contractData?.status === 4 || contractData?.status === 9) &&
      userData?.uuid === "074953d6-2cf3-468c-b5de-e46dd36101a1"
    ) {
      setPending(true);
      fetchPageData();
    } else {
      setPending(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractData?.status]);

  useEffect(() => {
    if (contractData?.domain_uuid && contractData?.seller_uuid) {
      fetchSellerTerms();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractData?.domain_uuid]);

  useEffect(() => {
    if (contractData?.domain_uuid !== "") {
      const fetchBasicDetails = async () => {
        const url = `/domains/${contractData?.domain_uuid}/details/basics`;
        try {
          const response = await axiosInstance.get(url);

          setBasicDetails(response?.data || {});
        } catch (error) {
          toast.error(t("There was an error fetching Basic Details"));
        }
      };

      fetchBasicDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractData?.domain_uuid]);

  const UpdateAction = (e, actionId, index) => {
    setDisable({ ...isDisable, action: true });
    e.preventDefault();
    if (!actionId) {
      toast.error(t("Invalid request"));
      return;
    }
    handleLoadingState(index, true);

    const url = `/users/${userData?.uuid}/contracts/${id}/${actionId}`;
    axiosInstance
      .put(url)
      .then((response) => {
        fetchAddressBar();
        handleLoadingState(index, false);
        if (response.status >= 200 && response.status < 300) {
          const acceptActionObj = actionData.find(
            (item) => item.action.action === "Accept"
          );
          if (acceptActionObj) {
            setIsValidPlacement(null);
          } else {
            setIsValidPlacement(true);
          }
          setPending(true);
        } else {
          setIsValidPlacement(false);
          setPending(false);
        }
        fetchContracts();
      })
      .catch(() => {
        toast.error(t("There was an error update Actions"));
        handleLoadingState(index, false);
        setDisable({ reason: false, action: false });
        setPending(false);
        setIsValidPlacement(null);
      });
  };

  const UpdateReason = (e, actionId, reasonId, index) => {
    e.preventDefault();
    if (!actionId || !reasonId) {
      toast.error(t("Invalid request"));
      setDisable({ ...isDisable, reason: false });
      return;
    }
    handleLoadingState(index, true);
    const url = `/users/${userData?.uuid}/contracts/${id}/${actionId}/${reasonId}`;
    axiosInstance
      .put(url)
      .then(() => {
        fetchAddressBar();
        fetchTimeline();
        handleLoadingState(index, false);
        navigate("/contracts");
        setDisable({ ...isDisable, reason: false });
      })
      .catch(() => {
        toast.error(t("There was an error update Actions"));
        handleLoadingState(index, false);
        setDisable({ ...isDisable, reason: false });
      });
  };

  const moneyBackPolicyType = {
    0: t("Not Provided"),
    1: `5 ${t("Days")}`,
    2: `10 ${t("Days")}`,
    3: `15 ${t("Days")}`,
    4: `20 ${t("Days")}`,
    5: `25 ${t("Days")}`,
    6: `30 ${t("Days")}`,
    7: `40 ${t("Days")}`,
    8: `50 ${t("Days")}`,
    9: `60 ${t("Days")}`,
    10: `70 ${t("Days")}`,
    11: `80 ${t("Days")}`,
    12: `90 ${t("Days")}`,
  };

  return (
    <main id="content" role="main" className="main">
      <div className="content">
        <div className="page-header row contract-detail-header">
          <div className="align-items-center mb-3 col-12 col-xl-3 col-xxl-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-no-gutter">
                <li className="breadcrumb-item">
                  {/* eslint-disable-next-line */}
                  <a href="javascript:;"
                    className="breadcrumb-link"
                    style={{
                      opacity: "0.6",
                      fontSize: "18px",
                      fontWeight: "400",
                    }}
                  >
                    {t("Contracts")}
                  </a>
                </li>
              </ol>
            </nav>
            <div className="d-md-flex justify-content-between align-items-center mb-sm-2 mb-2 mb-md-0">
              <h1
                className="page-header-title"
                style={{ fontSize: "28px", fontWeight: "700" }}
              >
                {t("Contract # ")}
                {contractData?.code}{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigator.clipboard
                      .writeText(id)
                      .then(() => {
                        toast.success(t("Contract code copied"));
                      })
                      .catch(() => {
                        toast.error(t("Failed to copy contract code"));
                      });
                  }}
                >
                  <path
                    d="M6.33333 6.33333H3C1.89543 6.33333 1 7.22877 1 8.33334V15C1 16.1046 1.89543 17 3 17H9.66667C10.7712 17 11.6667 16.1046 11.6667 15V11.6667M6.33333 6.33333H9.66667C10.7712 6.33333 11.6667 7.22876 11.6667 8.33333V11.6667M6.33333 6.33333V3C6.33333 1.89543 7.22877 1 8.33334 1H15C16.1046 1 17 1.89543 17 3V9.66667C17 10.7712 16.1046 11.6667 15 11.6667H11.6667"
                    stroke="#919293"
                    strokeWidth="1.5"
                  />
                </svg>
              </h1>
            </div>
          </div>
          <div className="col-12 col-xl-9 col-xxl-9 d-flex justify-content-end align-items-center">
            <div className="contract-header">
              <div>
                {contractData?.rel && (
                  <div>
                    {t("Placement Type")}
                    <h4
                      className="page-header-title"
                      style={{ fontSize: "20px", fontWeight: "700" }}
                    >
                      {placementItems[parseInt(contractData?.rel)]}
                    </h4>
                  </div>
                )}
              </div>

              {contractData?.type && (
                <div>
                  {t("Rel Type")}
                  <h4
                    className="page-header-title"
                    style={{ fontSize: "20px", fontWeight: "700" }}
                  >
                    {contractData?.links}{" "}
                    {linkTypeItems[parseInt(contractData?.type)]}
                  </h4>
                </div>
              )}

              <div>
                {t("Link Replacement")}
                <h4
                  className="page-header-title"
                  style={{ fontSize: "20px", fontWeight: "700" }}
                >
                  {contractData?.link_replacement_policy || 0} {t("Month")}
                  {contractData?.link_replacement_policy > 1 && t("s")}
                </h4>
              </div>

              <div>
                {t("Money Back")}
                <h4
                  className="page-header-title"
                  style={{ fontSize: "20px", fontWeight: "700" }}
                >
                  {moneyBackPolicyType[contractData?.money_back_policy]}
                </h4>
              </div>
              <div>
                {t("Price")}
                <h4
                  className="page-header-title"
                  style={{ fontSize: "20px", fontWeight: "700" }}
                >
                  ${contractData?.price || 0}
                </h4>
              </div>

              {stage?.formattedEndTime && (
                <div>
                  {t("Decision Due")}
                  <h4
                    className="page-header-title"
                    style={{ fontSize: "20px", fontWeight: "700" }}
                  >
                    {stage?.formattedEndTime}
                  </h4>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="contract_left g-5"
          style={{
            paddingRight: "30px !important",
            paddingLeft: "30px !important",
          }}
        >
          {isPending && (
            <div className="colapsible_I1 main_colapsable_check col-12 d-block d-xl-none col-xl-12 col-xxl-12 mb-3">
              <PlacementCheck
                isValidPlacement={isValidPlacement}
                checked={pageData?.checked || null}
              />
            </div>
          )}
          <div className="col-12 col-xl-8 col-xxl-8 contract_left_section mb-5">
            <div className="left_header p-3">
              <div>
                <h1
                  className="page-header-title"
                  style={{ fontSize: "24px", fontWeight: "700" }}
                >
                  {basicDetails?.domain || ""}{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    class="bi bi-person-check"
                    viewBox="0 0 16 16 "
                    style={{
                      color: "#91989e",
                      cursor: "pointer",
                      marginBottom: "5px",
                    }}
                  >
                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                    <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                  </svg>
                </h1>
                <div className="left_header_list">
                  {basicDetails?.categories &&
                  basicDetails?.categories?.length >= 1 ? (
                    <>
                      {basicDetails?.categories?.slice(0, 3).map((item, i) => (
                        <span key={i}>
                          {categoryOptions[parseInt(item?.value, 10)]}
                        </span>
                      ))}
                      {basicDetails?.categories?.length >= 3 && (
                        <span>
                          <i className="bi bi-three-dots"></i>
                        </span>
                      )}
                    </>
                  ) : (
                    <span>{t("Any Category")}</span>
                  )}
                </div>
              </div>
              <div>
                <div className="left-header-button">
                  {actionData &&
                    actionData?.length >= 1 &&
                    actionData?.map((item, index) => (
                      <>
                        <span className="btn-area-I1">
                          {item?.action?.stop === false &&
                            contractData?.status !== 1 &&
                            stage?.remainingTime && (
                              <>
                                <i class="bi bi-stopwatch"></i>{" "}
                                {stage?.remainingTime}{" "}
                              </>
                            )}
                        </span>
                        <div className="btn-group btn-area-I2" key={item?.id}>
                          {item?.action?.stop && (
                            <div
                              className={`${
                                isDisable?.reason ? "non-active" : "status-btn"
                              } btn-group `}
                              style={{
                                gap: "3px",
                                borderRadius: "10px",
                                width: "131px",
                                height: "47px !important",
                              }}
                              id={`dropdownMenuButtonWarning-${index}`}
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <button
                                type="button"
                                class="btn  btn-danger"
                                disabled={isDisable?.reason || false}
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "600",
                                }}
                              >
                                {loadingStates[index] ? (
                                  <Loader />
                                ) : (
                                  t(item?.action?.action)
                                )}
                              </button>
                              <button
                                type="button"
                                disabled={isDisable?.reason || false}
                                class="btn btn-danger 
                                dropdown-toggle 
                                dropdown-toggle-split"
                                style={{
                                  width: "35px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              ></button>

                              {item?.action?.stop &&
                                item?.reasons &&
                                item?.reasons?.length >= 1 && (
                                  <div
                                    className="dropdown-menu"
                                    aria-labelledby={`dropdownMenuButtonWarning-${index}`}
                                  >
                                    {item?.reasons?.map((ele, reasonIndex) => (
                                      <li
                                        className="dropdown-item"
                                        key={reasonIndex}
                                        onClick={(e) => {
                                          setDisable({
                                            ...isDisable,
                                            reason: true,
                                          });
                                          UpdateReason(
                                            e,
                                            item?.action?.id,
                                            ele?.id,
                                            reasonIndex
                                          );
                                        }}
                                      >
                                        {t(ele?.message)}
                                      </li>
                                    ))}
                                  </div>
                                )}
                            </div>
                          )}{" "}
                          {item?.action?.stop === false && (
                            <button
                              className="btn btn-area-I3 btn-primary"
                              disabled={isDisable?.action || false}
                              style={{
                                width: "111px",
                                height: "47px !important",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                              onClick={(e) =>
                                UpdateAction(e, item?.action?.id, index)
                              }
                            >
                              {loadingStates[index] ? (
                                <Loader />
                              ) : (
                                t(item?.action?.action)
                              )}
                            </button>
                          )}
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </div>
            {isPending && (
              <>
                <div className="divider-center">{t("Placement")}</div>
                <Placement
                  domain={basicDetails?.domain || ""}
                  pageData={pageData}
                  userData={userData?.uuid || ""}
                  isHide={isHide}
                  id={id || ""}
                  fetchPageData={fetchPageData}
                  value={value}
                />
              </>
            )}
            <div className="divider-center mt-3">{t("Content")}</div>
            <div className="contract-left-content">
              <h1>{value?.title || ""}</h1>
              <div
                dangerouslySetInnerHTML={{
                  __html: value?.content || "",
                }}
                className="cotract-sub-content"
              ></div>
            </div>
          </div>
          <div className="colapsible_main col-12 col-xl-4 col-xxl-4">
            <div className="row contract-sub-body">
              {isPending && (
                <div className="colapsible_I1 col-12 d-none d-xl-block col-xl-12 col-xxl-12 mb-3">
                  <PlacementCheck
                    isValidPlacement={isValidPlacement}
                    checked={pageData?.checked || null}
                  />
                </div>
              )}
              <br />
              <div className="colapsible_I1 main_colapsable col-12 col-xl-12 col-xxl-12">
                <CollapsibleCard
                  id="articlesfactory.com"
                  title={basicDetails?.domain || ""}
                  renderNode={
                    <ContractProgress
                      seller={sellerTerms}
                      basicDetails={basicDetails}
                    />
                  }
                />
              </div>
              <br />
              <div className="colapsible_I2 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-12 mt-3">
                <CollapsibleCard
                  id="quality_report"
                  title={`${t("Content Quality Report")}`}
                  status={isQualityReportActive}
                  renderNode={
                    <>
                      {QualityCheck?.map((item) => {
                        const { id, title, pass, tag, description } = item;
                        return (
                          <>
                            <CollapsibleCardItem
                              id={id}
                              title={title}
                              pass={pass}
                              tag={tag}
                              description={description}
                              renderNode={<p>{""}</p>}
                            />
                          </>
                        );
                      })}
                    </>
                  }
                />
              </div>
              <br />
              <div className="colapsible_I3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-12 mt-3">
                <CollapsibleCard
                  id="Contract Timeline"
                  title={`${t("Contract Timeline")}`}
                  renderNode={<ContractTimeline timeLine={timelineData} />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default ContractDetails;
